import { AuthProvider } from '@context/Auth';
import { InitializeProvider } from '@context/Initialize';
import { init } from '@noriginmedia/norigin-spatial-navigation';
import { PropsWithChildren } from 'react';

const Initializer = (props: PropsWithChildren) => {
  const { children } = props;

  init({
    debug: false,
    visualDebug: false,
    throttle: 300,
    throttleKeypresses: true
  });

  return (
    <AuthProvider>
      <InitializeProvider>{children}</InitializeProvider>
    </AuthProvider>
  );
};

export default Initializer;
